module.exports = __webpack_public_path__ + "img/edu.62988053.png";